module.exports = __webpack_public_path__ + "static/media/mascote_01.ed00b41d.jpg";